export class UpdateCommunicationLanguage {
  static readonly type = '[Settings] Update Communication Language';

  constructor(public communicationLanguage: string) {}
}

export class UpdateCommunicationLanguageSuccess {
  static readonly type = '[Settings] Update Communication Language Success';

  constructor(public communicationLanguage: string) {}
}

export class UpdateCommunicationLanguageError {
  static readonly type = '[Settings] Update Communication Language Error';
}
